import { render, staticRenderFns } from "./ManagementItem.vue?vue&type=template&id=4c7ec1b6&lang=pug"
import script from "./ManagementItem.vue?vue&type=script&lang=js"
export * from "./ManagementItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports